import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=48309ecc&scoped=true&"
import script from "./TextQuestion.vue?vue&type=script&lang=js&"
export * from "./TextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=48309ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48309ecc",
  null
  
)

export default component.exports